import { Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useContext } from "react";
import { DifficultWordsContext } from "../context";

export default function ExplainedStatement({
  statement,
}: {
  statement: string;
}) {
  const difficultWords = useContext(DifficultWordsContext);
  const mappedStatement = () => {
    /* Figure out all locations of difficult words */
    const lowercaseStatement = statement ? statement.toLowerCase() : "";
    const occurrences: Array<{
      description: string;
      startPos: number;
      endPos: number;
    }> = [];
    difficultWords.map((dw) => {
      if (!lowercaseStatement.includes(dw.word.toLowerCase())) {
        return;
      }

      const startPos = lowercaseStatement.indexOf(dw.word.toLowerCase());
      occurrences.push({
        description: dw.description,
        startPos,
        endPos: startPos + dw.word.length,
      });
    });

    /* Create a map of the statement with the textparts and description */
    const mappedStatement: Array<{ text: string; description?: string }> = [];
    if (occurrences.sort((o1, o2) => o1.startPos - o2.startPos).length) {
      occurrences.forEach((occ, index) => {
        /* Push string up to last occurrence */
        const prevOcc = occurrences[index - 1];
        mappedStatement.push({
          text: statement.substring(prevOcc?.endPos || 0, occ.startPos),
        });

        /* Push occurrence */
        mappedStatement.push({
          text: statement.substring(occ.startPos, occ.endPos),
          description: occ.description,
        });
      });
      /* Push last part of statement */
      const lastOcc = occurrences[occurrences.length - 1];
      mappedStatement.push({ text: statement.substring(lastOcc.endPos) });
    } else {
      mappedStatement.push({ text: statement });
    }
    return mappedStatement;
  };

  return (
    <h1 className="statement-text" id="explainedStatement">
      {mappedStatement().map((w, index) => {
        if (w.description) {
          return (
            <span
              key={index}
              data-word={w.text}
              className="statement-text__node"
            >
              {w.text}
              <span>
                <Tooltip
                  title={w.description}
                  arrow
                  enterTouchDelay={0}
                  leaveTouchDelay={12000}
                >
                  <InfoOutlinedIcon
                    className="tooltip"
                    data-tip
                    data-for={w.description}
                  />
                </Tooltip>
              </span>
            </span>
          );
        } else {
          return w.text;
        }
      })}
    </h1>
  );
}
